<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    Query(
      :query="require('~/graphql/Article.gql').Articles"
      :limit="10"
      :initialValue="articles"
      :variables="({ first, after }) => ({ first, after, publishedIn: 'BLOG' })"
      v-slot="{ items }"
    )
      AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
        AppCard.is-work(:img="[{ srcset: item.thumb, type: 'image/jpg', ratio }]" :ratio="ratio" :title="item.title" :url="`/blog/${item.slug}`")

  .u-mt-md
  Homer
  .u-mb-md

</template>

<script>
import Homer from '~/components/Homer';
import AsymetricGrid from '~/components/PsudoRandomGrid';
import { Articles } from '~/graphql/Article.gql';
import Query from '~/components/Query';

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },

  components: {
    Homer,
    AsymetricGrid,
    Query
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Articles,
      variables: {
        publishedIn: 'BLOG',
        first: 10
      }
    });

    return {
      articles: data.articles
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Blog ",
    "pageDesc":"Get game changing tips and hacks for your business and keep up with the latest trends and technologies.",
    "mantra":"Hack your growth |with insightful tips."
  },
  "ar": {
    "pageTitle":"مدونة بيانات",
    "pageDesc":"احصل على النصائح التى تساعدك على تطوير وتنمية أعمالك، وواكب أحدث الاتجاهات والتكنولوجيا التي تساعدك في ازدهارها.",
    "mantra":"نصائح وأسرار تمكنك |من ريادة مجالك."
  }
}
</i18n>
